import { render, staticRenderFns } from "./BugReportDialogue.vue?vue&type=template&id=f5483bc4&scoped=true&"
import script from "./BugReportDialogue.vue?vue&type=script&lang=js&"
export * from "./BugReportDialogue.vue?vue&type=script&lang=js&"
import style0 from "./BugReportDialogue.vue?vue&type=style&index=0&id=f5483bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5483bc4",
  null
  
)

export default component.exports